import React from "react";
import { Box } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

export const DescriptionSkeleton: React.FC = () => (
  <Box display="flex" flexDirection="row" alignItems="flex-start" margin="none">
    <Box
      display="flex"
      width="full"
      flexDirection="column"
      alignItems="flex-start"
    >
      <Skeleton width="30%" height={50} backgroundColor="dark" />
      <Skeleton variant="text" width="70%" backgroundColor="dark" />
      <Skeleton variant="text" width="20%" backgroundColor="dark" />
    </Box>
  </Box>
);
